import { Stack } from "@mui/material";
import { rootCauseCards } from "../../../data";
import { RootCauseCardReadOnly } from "../../../RootCauseCardReadOnly";

export const Specifications = () => {
	return (
		<Stack gap={2}>
			{rootCauseCards.map((card) => (
				<RootCauseCardReadOnly key={card.id} id={card.id} />
			))}
		</Stack>
	);
};
